import { IconCheck } from '@tabler/icons-react';
import styled, { css } from 'styled-components';

import { BRAND_COLORS } from 'brand-guidelines/colors';

import { commonInputStyles, FormInputProps } from 'brand-guidelines/input-styled-components';
import { applyStylesForScreenSize, SCREEN_SIZES } from 'brand-guidelines/utils/screenSizeUtils';
import { svgComponentToMarkupString } from 'utils/styledComponentSvg';

import { BaseBodyText } from './typographic-styled-components';

export const FormCheckboxWrapper = styled(BaseBodyText).attrs({ as: 'label' })`
  display: flex;
  align-items: flex-start;
  gap: 8px;

  text-align: left;
`;

const IconCheckDataUri = svgComponentToMarkupString(IconCheck, { color: BRAND_COLORS.white, size: 16 });
const IconCheckDataUriMobile = svgComponentToMarkupString(IconCheck, { color: BRAND_COLORS.white, size: 20 });

export const Checkbox = styled.input.attrs({ type: 'checkbox' })<FormInputProps>`
  ${commonInputStyles}

  align-self: flex-start;

  /* Allows us to override the default UA styles */
  appearance: none;

  display: flex;
  justify-content: center;
  align-items: center;

  background-color: transparent;

  flex-shrink: 0;

  width: 20px;
  height: 20px;

  border: 1px solid ${BRAND_COLORS.stroke};
  border-radius: 4px;

  transition-property: border-color, background-color;
  transition-duration: 100ms;
  transition-timing-function: ease-in-out;

  &:checked {
    background-color: ${BRAND_COLORS.darkGreen};
    border-color: ${BRAND_COLORS.darkGreen};

    &::before {
      content: url(${IconCheckDataUri});
      display: block;
      width: 16px;
      height: 16px;
      color: ${BRAND_COLORS.white};
    }
  }

  ${applyStylesForScreenSize(
    [SCREEN_SIZES.PHONE],
    css`
      width: 24px;
      height: 24px;

      &:checked::before {
        content: url(${IconCheckDataUriMobile});
        width: 20px;
        height: 20px;
      }
    `,
  )}
`;
